
import { Options, prop, Vue } from "vue-class-component";
import MainProducts from "./components/main-products.vue";
import MoreProducts from "./components/more-products.vue";
import LessProducts from "./components/less-products.vue";
import HighLightProducts from "./components/higlight-products.vue";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { SubmitPosterProductApiRequest } from "@/data/payload/api/BookingRequest";
import {
  PosterProduct,
  PayloadPosterProduct,
  FooterColorPosterProduct,
  ParameterActive,
  ComodityProductPoster,
  PiecesPosterProduct
} from "@/domain/entities/Booking";
import {
  productStyle,
  productHighlight,
  allProductsDefault,
  allProductsWithoutOnePacks,
  productSameday
} from "./data";
import { AccountController } from "@/app/ui/controllers/AccountController";
import formatPriceRP from "@/app/infrastructures/misc/common-library/FormatPriceRP";
import formatPriceRM from "@/app/infrastructures/misc/common-library/FormatPriceRM";
import { AccountEntities } from "@/domain/entities/Account";
import { BulkBookingController } from "@/app/ui/controllers/BulkBookingController";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { parseByCountry } from "@/app/infrastructures/misc/common-library/FormatInputByCountry";

class Props {
  productType = prop<string>({
    default: "",
    type: String,
  });
  isDisabledProduct = prop<boolean>({
    default: false,
    type: Boolean,
  });
  isOnePack = prop<boolean>({
    default: false,
    type: Boolean,
  });
  isJumboPack = prop<boolean>({
    default: false,
    type: Boolean
  });
  isSameday = prop<boolean>({
    default: false,
    type: Boolean
  });
  isShipmentCod = prop<boolean>({
    default: false,
    type: Boolean,
  });
  isEdit = prop<boolean>({
    default: false,
    type: Boolean,
  });
  isFormForeign = prop<boolean>({
    default: false,
    type: Boolean,
  });
  version = prop<string>({
    default: "v1",
    type: String
  });
  isEmbargo = prop<any>({
    default: false,
    type: Boolean
  });
  hideKgs = prop<boolean>({
    default: false,
    type:Boolean
  });
  bookingType = prop<string>({
    default: "",
    type: String
  });
  isBulkBooking = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  emits: ["choseeProduct", "setErrorTriggered", "setLoadingUpselling"],
  components: {
    MainProducts,
    MoreProducts,
    LessProducts,
    HighLightProducts,
  },
})
export default class ProductPoster extends Vue.with(Props) {
  origin = "";
  destination = "";
  shipmentId = "";
  isVisiblePrice = false;
  firstRender = true;
  loading = false;
  errorType = "";
  errorCause = "";

  errorTariff = {
    error: false,
    target: "Shipping Surcharge and Publish Rate price for selected route is not available",
    message: ""
  }
  originalData: PosterProduct[] = []

  mounted() {
    if (this.version === 'v2') {
      this.expandProduct();
    }
  }

  async getPosterProduct(
    shipmentId: string,
    origin: string,
    destination: string,
    isVisiblePrice: boolean,
    accountRefId: number,
    accountType: string,
    goodsPrice = "",
    commodity: any = "",
    pieces: any = [],
    isCod = false,
    isDfod = false
  ) {
    this.currentIndexProduct = 0;
    this.currentProduct = "";
    this.origin = origin;
    this.destination = destination;
    this.shipmentId = shipmentId;
    this.isVisiblePrice = isVisiblePrice;
    this.showButtonLessProduct = false;
    this.isExpandProduct = false;
    this.firstRender = false;
    this.errorType = "";
    this.errorCause = "";
    this.errorTariff.error = false;
    this.loading = true;
    this.$emit("setErrorTriggered", false);
    this.$emit("setLoadingUpselling", true);

    const goodsPriceNumber = goodsPrice ? parseByCountry(+goodsPrice) : 0;
    const defaultCODAmount = isCod ? 1 : 0;
    const codAmount =
      goodsPriceNumber == 0 ? defaultCODAmount : goodsPriceNumber;

    await BookingController.postToGetPosterProduct(
      new SubmitPosterProductApiRequest({
        payload: new PayloadPosterProduct({
          accountRefId: accountRefId,
          accountType: accountType,
          originId: origin,
          destinationId: destination,
          promoAppliedTo: this.isShipmentCod ? "shipment" : "",
          isDisablePromo: !this.isShipmentCod,
          shipmentPrefix: this.shipmentPrefix,
          goodsPrice: goodsPriceNumber,
          commodityId: typeof commodity === "object" ? +commodity?.id : 499,
          commodity: typeof commodity === "object" ? { data: new ComodityProductPoster({
            commodityId: +commodity?.id,
            commodityName: commodity?.name,
            commodityCode: commodity?.code
          })} : { data: new ComodityProductPoster() },
          pieces: pieces ? pieces : [new PiecesPosterProduct()],
          codAmount: codAmount,
          isCod: isCod,
          isDfod: isDfod
        }),
      })
    ).then((data: PosterProduct[]) => {
        this.mappingProduct(data, isVisiblePrice);
        this.originalData = data;
        const everyEmbargo = this.originalData.every(key => key.isEmbargo);
        BookingController.setProductHaveEmbargo(everyEmbargo);
    }).catch((error: any) => {
      this.resetAllProduct();
      this.$emit("setErrorTriggered", true);
      const errorTariff = (error?.response?.data?.message?.en?.toLowerCase() || '') === this.errorTariff.target.toLowerCase()
      if (errorTariff) {
        this.errorTariff.error = true;
        this.errorTariff.message = this.$t("Rute yang dipilih belum memiliki tarif pengiriman")
      }

      if (error?.response?.data.code >= 400 ) {
        this.errorType = "errorData";
        this.errorCause = this.$t("Terjadi gangguan sistem untuk kota tujuan Anda karena alasan tertentu")
      }

      if (error?.response?.data.code >= 500 || error.response === undefined) {
        this.errorType = "errorServer";
        this.errorCause = this.$t("Jenis Pengiriman Gagal Ditampilkan")
      }
    }).finally(() => {
        this.loading = false;
      this.$emit("setLoadingUpselling", false);
      if (this.version === 'v2')this.expandProduct();
    })
  }
  get isShipmentCod() {
    return /^ARA|^ARB/.test(this.shipmentId);
  }
  get isShipmentTkp() {
    return /^TKP/.test(this.shipmentId);
  }
  get shipmentPrefix() {
    return this.isShipmentCod || this.isShipmentTkp
      ? this.shipmentId.slice(0, 3)
      : this.shipmentId.slice(0, 2);
  }

  products: PosterProduct[] = this.isOnePack ? this.productOnePackWithJumbopack : this.productNonOnePackWithJumboPack;
  productHighlight: PosterProduct = productHighlight;
  productSameday: PosterProduct = productSameday;
  mappingProduct(productPosters: PosterProduct[], isVisiblePrice: boolean) {
    const productOrders = this.getProductOrders();
    const productOrdersHiglight = ["sameday", "bosspack"];

    this.products = this.loopProducts(productOrders, productPosters, isVisiblePrice);
    this.productHighlight = this.loopProducts(productOrdersHiglight, productPosters, isVisiblePrice)[1];
    this.productSameday = this.loopProducts(productOrdersHiglight, productPosters, isVisiblePrice)[0];

    if (!this.isShipmentCod) {
      this.handleAutoSelection(productPosters);
    }
  }

  private getProductOrders(): string[] {
    const filterProduct = FlagsPermissionBooking.config_filter_product_list.getValue();

    let productOrders = [
      "onepack",
      "regpack",
      "minipack",
      "jagopack",
      "bigpack",
      "bigpackfast",
      "interpack",
      "interpackmaxi",
      "otopack150",
      "otopack250",
      "vippack"
    ].filter(item => !filterProduct.includes(item));

    if (this.isJumboPack && this.allowedJumbopackAccess) {
      productOrders.splice(4, 0, "jumbopack");
    }
    if (!this.isOnePack) {
      productOrders = productOrders.filter(item => item !== "onepack");
    }
    if (!this.isBigpackfastEnabled) {
      productOrders = productOrders.filter(
        (product) => product !== "bigpackfast"
      );
    }

    if (!this.accountData.accountIsForeign) {
      return productOrders.filter(e => e !== "interpackmaxi");
    }

    return productOrders;
  }

  get isBigpackfastEnabled() {
    return FlagsPermissionBooking.config_show_bigpack_fast.isEnabled();
  }

  private handleAutoSelection(productPosters: PosterProduct[]) {
    const isAutoSelect = this.version === "v2" && !this.productType;

    if (isAutoSelect) {
      this.autoSelectProduct();
    } else {
      this.handleHighlightSelection(productPosters);
    }
  }

  private handleHighlightSelection(productPosters: PosterProduct[]) {
    const ceckBosspack = productPosters.find(item => item.name === "bosspack");
    const ceckSameday = productPosters.find(item => item.name === "sameday");

    if (ceckBosspack && !this.productType) {
      this.updateActiveHighLightProduct();
    }
    if (ceckSameday && !this.productType) {
      this.updateActiveHighLightProductSameday();
    }

    const isProductHighlights = ["sameday", "bosspack"].includes(this.productType);
    if (isProductHighlights) {
      this.productHighlight.statusSelect = true;
      this.productSameday.statusSelect = this.isSameday;
    }
  }

  _getSelectedProductFromBulkBooking(products: any, currentProductName: any) {
    const bulkBookingCurrentProductName = BookingController.manualBooking.productName
      ? BookingController.manualBooking.productName.toLowerCase()
      : "";
    const activeProducts = products.filter((product: any) => product.statusActive) as any;
    let selectedProduct = activeProducts.find((product: any) => product.name.toLowerCase() === currentProductName.toLowerCase()) || {name: ""}

    if (this.isBulkBooking) {
      selectedProduct = activeProducts.find((product: any) => product.name.toLowerCase() === bulkBookingCurrentProductName.toLowerCase()) || {name: ""}
    }

    return selectedProduct.name;
  }

  autoSelectProduct() {
    const data = [this.productHighlight, ...this.products].filter(
      key => key.statusActive
    );
    if (data.length <= 0) {
      return;
    }

    let currentProductName = BookingController.manualBooking.productName
      ? BookingController.manualBooking.productName.toLowerCase()
      : data[0].name.toLowerCase();

    if (this.isBulkBooking) {
      currentProductName = this._getSelectedProductFromBulkBooking(data, currentProductName);
    }

    if (!currentProductName && this.isBulkBooking) {
      BookingController.setProductName("");
      this.$emit("clearProducts");
      return;
    };

    if (currentProductName.toLowerCase() === "bosspack") {
      this.updateActiveHighLightProduct();
      this.currentIndexProduct = 0;
    } else {
      const findIndex = this.products.findIndex(
        key => key.name === currentProductName
      );
      if (findIndex > -1) {
        this.setActiveMainProduct(findIndex, currentProductName);
        this.currentIndexProduct = findIndex;
      }
    }
    BookingController.setProductName(currentProductName.toUpperCase());
  }

  loopProducts(productOrders: string[], productPosters: PosterProduct[], isVisiblePrice: boolean) {
    const data = [];
    for (const product of productOrders) {
      const productDetail = this.convertDetail(productPosters, product, isVisiblePrice);
      const checkProductAvailable = productPosters.find((item: PosterProduct) => item.name === product);
      const productInactive =  !this.checkProductUndefined(checkProductAvailable);
      const newData = new PosterProduct({
        name: product,
        icon: productStyle[product].icon,
        motto: productStyle[product].motto,
        price: productDetail.price,
        sla: productDetail.sla,
        color: productInactive 
          ? this.convertColorInactive(product).color 
          : productStyle[product].color,
        footer: new FooterColorPosterProduct({
          firstColor: productStyle[product].footer.firstColor,
          secondColor: productInactive
            ? this.convertColorInactive(product).footer
            : productStyle[product].footer.secondColor,
        }),
        discountAgentPrecentage: productDetail.discountAgentPrecentageFinal,
        discountAgentNominal: productDetail.discountAgentNominal,
        statusCard: !productInactive || this.cardActive(product),
        statusSelect: this.statusSelect(product, !productInactive),
        statusActive: !productInactive,
        isEmbargo: productDetail.isEmbargo
      });

      data.push(newData);
    }
    return data;
  }

  statusSelect(product: string, statusActive: boolean) {
    if (this.isActiveInterpackProduct(this.currentProduct, statusActive) && this.isFormForeign) {
      this.$emit("choseeProduct", {
        status: "ACTIVE",
        name: "INTERPACK"
      });
      
      return true;
    } else {
      return product === this.productType;
    }
  }

  isActiveInterpackProduct(product: string, statusActive: boolean) {
    return product === "interpack" && statusActive
  }

  get isNonForeign() {
    if (this.isEdit && this.isFormForeign) {
      return false;
    } else if(this.isEdit && !this.isFormForeign) {
      return true;
    } else {
      return !AccountController.accountData.accountIsForeign;
    }
    
  }

  get accountData(): AccountEntities {
    return AccountController.accountData;
  }
  get partnerIsAllowBookVippack(): boolean {
    return this.isEdit
      ? this.productType === "vippack"
      : this.accountData.account_type_detail?.partnerIsAllowBookVippack &&
          this.bookingType === "manual" &&
          this.accountData.account_type === "partner";
  }
  availableProducts(data: PosterProduct[]): PosterProduct[] {
    const productOrders = FlagsPermissionBooking.config_filter_product_list.getValue();
    const mottoDataToPushed = data.find(item => item.name === this.productType)?.motto || "";

    const filteredData = data
      .filter(
        (item: PosterProduct) =>
          this.partnerIsAllowBookVippack || item.name !== "vippack"
      )
      .filter((item) => !productOrders.includes(item.name)); // exclude yang ada di productOrders

    const validationEditProduct = !!this.productType && this.productType.toLowerCase() !== 'bosspack' && !filteredData.some((item) => item.name === this.productType.toLowerCase())

    if (validationEditProduct && !this.isBulkBooking) {
      filteredData.push({
        name: this.productType.toLowerCase(),
        icon: this.productType.toLowerCase(),
        color: "#a7a8aa",
        discountAgentNominal: "-",
        discountAgentPrecentage: "-",
        footer: {
          firstColor: "#ffffff",
          secondColor: "#d4d5d8"
        },
        isEmbargo: false,
        motto: mottoDataToPushed,
        price: "Rp-",
        sla: "-",
        statusActive: false,
        statusCard: false,
        statusSelect: false
      } as PosterProduct);
    }

    return filteredData;
  }
  get productOnePackWithJumbopack() {
    const newProductFilter = this.isNonForeign
      ? allProductsDefault.filter((item) => item.name !== "interpackmaxi")
      : allProductsDefault;
    const newProducts = this.isJumboPack
      ? newProductFilter
      : newProductFilter.filter(
          (item: PosterProduct) => item.name !== "jumbopack"
        );
    const productWithBigpackFast = this.isBigpackfastEnabled
      ? newProducts
      : newProducts.filter(
          (item: PosterProduct) => item.name !== "bigpackfast"
        );
    return this.availableProducts(productWithBigpackFast);
  }

  get productNonOnePackWithJumboPack() {
    const newProductFilter = this.isNonForeign
      ? allProductsWithoutOnePacks.filter(
          (item) => item.name !== "interpackmaxi"
        )
      : allProductsWithoutOnePacks;
    const newProducts = this.isJumboPack
      ? newProductFilter
      : newProductFilter.filter(
          (item: PosterProduct) => item.name !== "jumbopack"
        );
    const productWithBigpackFast = this.isBigpackfastEnabled
      ? newProducts
      : newProducts.filter(
          (item: PosterProduct) => item.name !== "bigpackfast"
        );
    return this.availableProducts(productWithBigpackFast);
  }

  resetAllProduct() {
    this.firstRender = true;
    this.errorType = "";
    this.errorCause = "";
    this.errorTariff.error = false;
    const products = this.isOnePack ? this.productOnePackWithJumbopack : this.productNonOnePackWithJumboPack;
    this.products = products?.map((item: PosterProduct) => {
      return new PosterProduct({
        name: item.name,
        icon: item.icon,
        motto: item.motto,
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false
      })
    }) || [];

    this.productHighlight = new PosterProduct({
      name: "BOSSPACK",
      icon: "bosspack",
      motto: this.$t("Pengiriman Prioritas"),
      price: "Rp-",
      sla: "-",
      color: "#a7a8aa",
      footer: {
          firstColor: "#ffffff",
          secondColor: "#a7a8aa",
      },
      discountAgentPrecentage: "-",
      discountAgentNominal: "-",
      statusCard: false,
      statusSelect: false,
      statusActive: false
    });

    this.productSameday = new PosterProduct({
      name: "SAMEDAY",
      icon: "sameday",
      motto: this.$t("Paket sampai di hari<br> yang sama"),
      price: "Rp-",
      sla: "-",
      color: "#a7a8aa",
      footer: {
          firstColor: "#ffffff",
          secondColor: "#a7a8aa",
      },
      discountAgentPrecentage: "-",
      discountAgentNominal: "-",
      statusCard: false,
      statusSelect: false,
      statusActive: false
    });

    if (this.isBulkBooking && this.errorTariff.error) {
      BookingController.setProductName("");
    }
  }

  setActiveProductDisabled(productType = "") {
    const product = productType === 'jumbopackh2h' ? 'jumbopack' : productType ? productType : this.productType
    this.resetAllProduct()
    const checkMainProductIndex = this.products.findIndex((item: PosterProduct) => item.name === product);
    if (checkMainProductIndex > -1) this.setActiveMainProduct(checkMainProductIndex, product);
    if (product === "bosspack") this.setActiveHighlightProduct(product);
    if (product === "sameday") this.setActiveHighlightProductSameday(product);
  }

  setActiveHighlightProductSameday(productType: string) {
    this.firstRender = false;
    this.productSameday.statusSelect = true;
    this.productSameday.statusCard = true;
    this.productSameday.statusActive = true;
    this.productSameday.color = productStyle[productType].color;
    this.productSameday.footer.firstColor = productStyle[productType].footer.firstColor;
    this.productSameday.footer.secondColor = productStyle[productType].footer.secondColor;
  }

  disableProductShipmentCod = false;
  isBosspackShipmentCod = true;
  setProductShipmentCod(productType: string) {
    const checkMainProductIndex = this.products.findIndex((item: PosterProduct) => item.name === productType && item.statusActive);
    const checkBosspack = this.productHighlight.name === productType && this.productHighlight.statusActive;

    if (checkMainProductIndex > -1 || checkBosspack) {
      this.disableProductShipmentCod = true;
      this.setProductShipmentCodExist(checkBosspack, checkMainProductIndex, productType);
    } else {
      this.disableProductShipmentCod = false;
      this.mappingProduct(this.originalData, this.isVisiblePrice);
    }
  }

  setProductShipmentCodExist(checkBosspack: boolean, checkMainProductIndex: number, productType: string) {
    if (checkBosspack) {
      this.setActiveHighlightProduct(productType);
    } else {
      this.setActiveMainProduct(checkMainProductIndex, productType);
    }

    this.$emit("choseeProduct", {
      status: "ACTIVE",
      name: productType.toUpperCase()
    });
  }

  setActiveMainProduct(index: number, productType: string) {
    this.products[index].statusSelect = true;
    this.products[index].statusCard = true;
    this.products[index].statusActive = true;
    this.products[index].color = productStyle[productType].color;
    this.products[index].footer.firstColor = productStyle[productType].footer.firstColor;
    this.products[index].footer.secondColor = productStyle[productType].footer.secondColor;
  }

  setActiveHighlightProduct(productType: string) {
    this.firstRender = false;
    this.productHighlight.statusSelect = true;
    this.productHighlight.statusCard = true;
    this.productHighlight.statusActive = true;
    this.productHighlight.color = productStyle[productType].color;
    this.productHighlight.footer.firstColor = productStyle[productType].footer.firstColor;
    this.productHighlight.footer.secondColor = productStyle[productType].footer.secondColor;
  }

  convertColorInactive(product: string) {
    const productColor: any = {
      bosspack:{
        color:  "#a7a8aa",
        footer:  "#a7a8aa"
      }
    }
    return productColor[product] || {
      color:  "#a7a8aa",
      footer:  "#d4d5d8"
    }
  }

  checkProductUndefined(checkProductAvailable: any) {
    return !!checkProductAvailable
  }

  cardActive(product: string) {
    return product === this.productType;
  }

  convertDetail(productPosters: PosterProduct[], product: string, isVisiblePrice: boolean) {
    const productDetail = isVisiblePrice ? productPosters.find(
      (item: PosterProduct) => item.name === product
    ) : null;

    const discountAgentPercentage = product !== "bigpack" ? `${productDetail?.discountAgentPrecentage}%` : "";
    const units: any = {
      "bigpack": "/10kg awal",
      "bigpackfast": "/10kg awal",
      "onepack": "/kg",
      "regpack": "/kg",
      "jagopack": "/kg",
      "interpack": "/kg",
      "interpackmaxi": "/kg",
      "sameday": "/kg",
      "bosspack": "/kg",
      "jumbopack": "/30kg awal"
    }

    const suffixPrice = units[product] || "";
    return {
      price: productDetail ? `${this.formatCurrency(Number(productDetail.price))}${suffixPrice}` : this.defaultPriceLabel,
      discountAgentPrecentageFinal: productDetail ? `${discountAgentPercentage}` : "-",
      sla: productDetail ? (`${productDetail.sla} ${this.defaultSLALabel}`).toLowerCase() : "-",
      discountAgentNominal: productDetail ? `${this.formatCurrency(Number(productDetail?.discountAgentNominal))}${suffixPrice}` : "-",
      isEmbargo : productDetail ? productDetail.isEmbargo : false
    }
  }

  get defaultPriceLabel() {
    return this.isFormForeign ? "RM-" : "Rp-";
  }

  get defaultSLALabel() {
    return this.isFormForeign ? "days" : "kerja";
  }

  formatCurrency(value: any) {
    return this.isFormForeign
      ? formatPriceRM(Number(value))
      : formatPriceRP(Number(value));
  }

  isExpandProduct = false;
  expandProduct() {
    this.isExpandProduct = true;
    this.showButtonLessProduct = true;
  }

  showButtonLessProduct = false;
  unExpandProduct() {
    this.isExpandProduct = false;
    this.showButtonLessProduct = false;
  }

  currentIndexProduct = 0;
  currentProduct = "";
  updateProductActive(parameter: ParameterActive) {
    this.productHighlight.statusSelect = false;
    this.productSameday.statusSelect = false;
    this.products[this.currentIndexProduct].statusSelect = false;
    this.currentIndexProduct = parameter.index;
    this.currentProduct = parameter.product;
    this.products[parameter.index].statusSelect = true;

    parameter.product === "interpack" || parameter.product === "interpackmaxi" ? this.pickInterpack() : this.pickNonInterpack();
    this.$emit("choseeProduct", {
      status: "ACTIVE",
      name: this.currentProduct.toUpperCase()
    });
  }

  pickInterpack() {
    this.products.forEach((item: PosterProduct, index: number) => {
      if (item.name !== "interpack" && item.name !== "interpackmaxi") {
        if (item.statusActive) {
          this.products[index].color = "#a7a8aa";
          this.products[index].footer.secondColor = "#d4d5d8";
          this.products[index].statusCard = false;
        }
      } else {
        if (item.statusActive) {
          this.products[index].color = "#d64f71";
          this.products[index].footer.secondColor = "#f4dfe7";
          this.products[index].statusCard = true;
        }
      }
    })

    if (this.productHighlight.statusActive || this.productSameday.statusActive) {
      this.productHighlight.color = "#a7a8aa";
      this.productHighlight.footer.secondColor = "#a7a8aa";
      this.productHighlight.statusCard = false;
      this.productSameday.color = "#a7a8aa";
      this.productSameday.footer.secondColor = "#a7a8aa";
      this.productSameday.statusCard = false;
    }
  }

  pickNonInterpack() {
    this.products.forEach((item: PosterProduct, index: number) => {
      if (item.name === "interpack" || item.name === "interpackmaxi") {
        if (item.statusActive) {
          this.products[index].color = "#a7a8aa";
          this.products[index].footer.secondColor = "#d4d5d8";
          this.products[index].statusCard = false;
        }
      } else {
        if (item.statusActive) {
          this.products[index].color = productStyle[item.name].color;
          this.products[index].footer.secondColor = productStyle[item.name].footer.secondColor;
          this.products[index].statusCard = true;
        }
      }
    })

    if (this.productHighlight.statusActive) {
      this.productHighlight.color = productStyle["bosspack"].color;
      this.productHighlight.footer.secondColor = productStyle["bosspack"].footer.secondColor;
      this.productHighlight.statusCard = true;
      this.productSameday.color = "#a7a8aa";
      this.productSameday.footer.secondColor = "#a7a8aa";
      this.productSameday.statusCard = false;
    }
  }

  updateActiveHighLightProduct() {
    this.currentProduct = "bosspack";
    this.products[this.currentIndexProduct].statusSelect = false;
    this.productHighlight.statusSelect = true;
    this.pickNonInterpack();
    this.$emit("choseeProduct", {
      status: "ACTIVE",
      name: this.currentProduct.toUpperCase()
    });
  }

  updateActiveHighLightProductSameday() {
    this.currentProduct = "sameday";
    this.products[this.currentIndexProduct].statusSelect = false;
    this.productSameday.statusSelect = true;
    this.pickNonInterpack();
    this.$emit("choseeProduct", {
      status: "ACTIVE",
      name: this.currentProduct.toUpperCase()
    });
  }

  get allowedJumbopackAccess() {
    return BookingController.dataProfile.isInternalAccount || BookingController.dataProfile.isPartnerPcu || BookingController.dataProfile.isAllClient;
  }

  get isErrorRepair() {
    return BulkBookingController.isErrorRepair;
  }
}
